<div class="notification-inner">
  <cue-icon [icon]="ICONS.cueCheckCircle" class="icon" />
  <div class="flex flex-column gap-1">
    <h2 [innerHTML]="translation.notifications.eventCreated | transloco: { subject: subject() }"></h2>
    <a class="show-link" [routerLink]="['/dashboard']" [queryParams]="{ eventId: id(), email: email() }">{{
      translation.notifications.showTheEvent | transloco
    }}</a>
  </div>
</div>
